import BaseModelComponent from "../../../base/base_model_component";
import { IAlteredFreePlayVoucher } from "../voucher/free_play_voucher_consts";
import FreePlayComponentController from "../free_play_component_controller";

export default class FPVouchersComponentModel extends BaseModelComponent {
    static CLASS = 'FPVouchersComponentModel';

    private _vouchers: IAlteredFreePlayVoucher[];
    private _containerRef: FreePlayComponentController;
    private _title: string;
    private _scrollingOptions: string;


    /**
     *
     * @param params
     */
    init(params: any = {}) {
        super.init(params);
        if (params) {
            this.setScrollingOptions(params.scrollingOptions)
                .setVouchers(params.vouchers)
                ._setContainerRef(params.container)
                ._setTitle(params.title);
        }
    }


    /**
     * Set initial direction of vouchers list
     * @param direction
     * @returns {FPVouchersComponentModel}
     * @private
     */
    setScrollingOptions(scrollingOptions) {
        this._scrollingOptions = scrollingOptions;
        return this;
    }


    /**
     * Set vouchers to be injected to the list
     * @param vouchers
     * @returns {FPVouchersComponentModel}
     * @private
     */
    setVouchers(vouchers) {
        this._vouchers = vouchers;
        return this;
    }


    /**
     * Set reference to parent container
     * @param container
     * @returns {FPVouchersComponentModel}
     * @private
     */
    private _setContainerRef(container) {
        this._containerRef = container;
        return this;
    }


    /**
     * Set title for component
     * @param title
     * @returns {FPVouchersComponentModel}
     * @private
     */
    private _setTitle(title) {
        this._title = title;
        return this;
    }


    /**
     * Get vouchers list direction
     * @returns {*}
     */
    getScrollingOptions() {
        return this._scrollingOptions;
    }


    /**
     * Get FP vouchers
     * @returns {*}
     */
    getVouchers() {
        return this._vouchers;
    }


    /**
     * Get component title
     * @returns {*}
     */
    getTitle() {
        return this._title;
    }


    /**
     * Get container reference
     * @returns {*}
     */
    getContainerRef() {
        return this._containerRef;
    }
}
